import type { ProductMinimal } from '@travelity/api';

export const getDurationMinutesFromProduct = (
    product: (ProductMinimal & { start_time?: string }) | undefined
): number | null => {
    if (!product) return null;
    const hours = Number(product.schedule?.[0]?.duration?.estimated?.hours);
    const minutes = Number(product.schedule?.[0]?.duration?.estimated?.minutes);

    const hoursSafe = Number.isFinite(hours) ? hours : 0;
    const minutesSafe = Number.isFinite(minutes) ? minutes : 0;

    if (hoursSafe < 0 || minutesSafe < 0) return null;
    if (hoursSafe === 0 && minutesSafe === 0) return null;

    return hoursSafe * 60 + minutesSafe;
};
